<template>
  <tr>
    <td class="grey--text text--darken-1 text-xs-center">
      <b>
        {{ item.Datum | moment("DD.MM.YYYY.") }}
      </b>
    </td>
    <td class="text-xs-center">
      <b class="grey--text text--darken-1">
        {{item.TerminOd | moment("HH:mm")}} - {{item.TerminDo | moment("HH:mm")}}
      </b>
    </td>
    <td class="grey--text text--darken-1 text-xs-left">
      {{item.Ucionica}}
    </td>
    <td class="grey--text text--darken-1">
      {{item.Ulica}}, {{item.Grad}}
    </td>
    <td class="text-xs-center">
      <v-btn small color="cyan" @click="prijaviIspit()" class="white--text" :disabled="rokPrijaveIstekao()">
        <v-icon class="white--text"> edit</v-icon>
        <span class="white--text"> &nbsp;&nbsp;&nbsp; {{ $t('exam_register.terms_table.btn_register_exam') }} </span>
      </v-btn>
    </td>
  </tr>
</template>


<script>
  import moment from 'moment';

  export default {
    name: 'ExamTR',
    props: {
      item: {},
      index: ''
    },
    data() {
      return {

      }
    },
    methods: {
      rowEvent() {

      },
      prijaviIspit() {
        this.$emit('examRowClick', { index: this.index, item: this.item });
      },

      rokPrijaveIstekao() {
        var datum = new Date(this.item.Datum);
        var terminOd = new Date(this.item.TerminOd);

        var danaPrije = 20; // Koliko dana ranije mora biti ispit prijavljen
        var currentDatePlus48h = new Date();
        currentDatePlus48h.setDate(currentDatePlus48h.getDate() + danaPrije);

        var prvi = moment(currentDatePlus48h);
        var drugi = new Date(datum.getFullYear(), datum.getMonth(), datum.getDate(), terminOd.getHours(), terminOd.getMinutes(), 0);
        drugi = moment(drugi);

        var razlika = drugi.diff(prvi);

        // Prema gornjoj logici, 0 je točno u vrijeme ispita, pa onda ako je manje od 0, ne može više prijaviti
        return razlika < 0;
      }
    },
    mounted() {

    }
  }
</script>

<style scoped>
  td {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }
</style>






// WEBPACK FOOTER //
// VueSrc/Exams/exam_register_components/ExamTR.vue